import React, { useState, useImperativeHandle, useEffect, forwardRef } from 'react'
import Api from '../../../../_helpers/Api'
import { useCurrencyContext } from '../../../../_providers/Currency'
import { trans } from '../../../../_providers/Translation'

//images
import docIcon from '../../../../assets/img/icons/document.png'
import closeIcon from '../../../../assets/img/icons/close.png'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"
import loader from '../../../../assets/img/loader.svg'
import Currencies from './Currencies'

function AddOrEdit(props, ref) {

    const currencies = useCurrencyContext()

    const defaultData = {
        prices_keyed: {}
    }

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        edit: false,
        editId: null,
        data: defaultData,
        loading: false,
        currencyTab: currencies[0] ? currencies[0].id : 0
    })

    const [validations, setValidations] = useState(null)

    useImperativeHandle(ref, () => ({
        add: () => {
            setPopup(prev => ({
                ...prev,
                edit: false,
                loading: false,
                data: defaultData
            }))
            handleShow()
        },
        edit: (id) => {
            setPopup(prev => ({
                ...prev,
                edit: Math.random().toString(),
                editId: id,
                data: defaultData,
                loading: false
            }))
            handleShow()
        },
        hide: () => {
            handleHide()
        }
    }))

    // при редакция извлича текущите данни, за да се попълнят полетата
    useEffect(() => {
        if (popup.edit) {
            Api.get(`sms-packets/find?id=${popup.editId}`)
                .then(res => {
                    setPopup(prev => ({
                        ...prev,
                        data: res.data,
                    }))
                })
        }

    }, [popup.edit])

    useEffect(() => {
        if (currencies.length) {
            setPopup(prev => ({ ...prev, currencyTab: currencies[0].id }))
        }
    }, [currencies, popup.edit])

    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false
            }))
        }, 50)
    }

    const handleSave = e => {
        e.preventDefault()


        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        setValidations(null)

        let url

        if (popup.edit) {
            url = 'sms-packets/edit'
        } else {
            url = 'sms-packets/add'
        }

        let data = new FormData(e.target)

        // при редакция - добавяме ID
        if (popup.edit) {
            data.append('id', popup.editId)
        }

        Api.post(url, data)
            .then(res => {

                if (popup.edit) {
                    props.handleUpdate(res.data)
                } else {
                    props.handleCreate(res.data)
                }

                handleHide(e)

                document.getElementById("form").reset()

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }))

                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        })
                    }
                }

            })
    }

    const handleInputChange = e => {
        let name = e.target.name
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }

    const handlePriceChange = (currencyId, price) => {

        let prices = Object.assign({}, popup.data.prices_keyed)

        if (!prices[currencyId]) {
            prices[currencyId] = {}
        }

        prices[currencyId] = price

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                prices_keyed: prices
            }
        }))
    }

    const handleCurrencyTabChange = newValue => {
        setPopup(popup => ({
            ...popup,
            currencyTab: newValue,
        }))
    }

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form className={`${popup.modal ? 'show' : ''} popup-primary small`} onSubmit={handleSave}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {popup.edit ? trans('headings.editSmsPackages') : trans('headings.addSmsPackages')}
                        </h2>
                        <p>{trans('subheadings.editSmsPackages')}</p>
                    </div>
                    <span className='close' onClick={handleHide}>

                    </span>
                </div>

                <div className='popup-container'>
                    <div className='col'>
                        <label>{trans('labels.type')}</label>
                        <select
                            name='type_id'
                            value={popup.data && popup.data.type_id ? popup.data.type_id : ''}
                            onChange={handleInputChange}
                            className={validations && validations.type_id ? 'validate' : ''}
                        >
                            <option value={1}>SMS</option>
                            <option value={2}>Viber</option>
                            <option value={3}>WhatsApp</option>
                        </select>
                    </div>
                </div>

                <br />

                <div className='popup-container'>
                    <div className='col'>
                        <label>{trans('labels.count')}</label>
                        <input
                            type='text'
                            name='count'
                            value={popup.data && popup.data.count ? popup.data.count : ''}
                            onChange={handleInputChange}
                            className={validations && validations.count ? 'validate' : ''}
                        />
                    </div>
                </div>

                <br />

                <Currencies
                    tab={popup.currencyTab}
                    callbackValue={handleCurrencyTabChange}
                />

                {currencies.map(c =>
                    <div key={'c' + c.id} className="field-primary" style={{ display: popup.currencyTab === c.id ? 'block' : 'none' }}>
                        <div className="popup-container">
                            <div className="col">
                                <label>
                                    {trans('labels.price')}
                                </label>
                                <input
                                    id="price"
                                    type="number"
                                    name={`prices[${c.id}]`}
                                    min="0"
                                    step="0.01"
                                    value={popup.data && popup.data.prices_keyed && popup.data.prices_keyed[c.id] ?
                                        popup.data.prices_keyed[c.id]
                                        :
                                        ''
                                    }
                                    className={validations && validations.prices && validations.prices[c.id] ? 'validate' : ''}
                                    onChange={e => handlePriceChange(c.id, e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                )}

                <br />

                <div className="footer align-right">
                    {popup.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button className="button" onClick={handleHide}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    }
                </div>
            </form>
        </div>
    )
}

export default forwardRef(AddOrEdit)